import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=9a9eaa34&scoped=true"
import script from "./PayPal.vue?vue&type=script&lang=js"
export * from "./PayPal.vue?vue&type=script&lang=js"
import style0 from "./PayPal.vue?vue&type=style&index=0&id=9a9eaa34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9eaa34",
  null
  
)

export default component.exports